import PdfTemplateModelMC from '../../../models/PdfTemplateModelMC';
import { normalizeEditorConfig } from '../editor/editorConfigUtils';

const mapFromApi = (template) => {
  if (!template) return null;

  const normalizedConfig = normalizeEditorConfig(template.config);

  return {
    id: template.web_id,
    name: template.name || 'Sin nombre',
    isDefault: Boolean(template.is_default),
    documentType: template.document_type || 'quote',
    config: normalizedConfig,
    updatedAt: template.updated_at
  };
};

export const listTemplates = async () => {
  const response = await PdfTemplateModelMC.get();
  const templates = response.pdf_templates || [];
  return templates
    .map(mapFromApi)
    .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
};

export const getTemplate = async (_retailerSlug, id) => {
  if (!id) return null;

  try {
    const response = await PdfTemplateModelMC.findById(id);
    return mapFromApi(response.pdf_template || response);
  } catch {
    return null;
  }
};

export const saveTemplate = async (_retailerSlug, template) => {
  const pdfTemplate = {
    name: template.name || 'Sin nombre',
    document_type: 'quote',
    config: normalizeEditorConfig(template.config) || template.config || ''
  };

  // Only send is_default when explicitly set (avoid clearing default on normal save)
  if (typeof template.isDefault === 'boolean') {
    pdfTemplate.is_default = template.isDefault;
  }

  const payload = { pdf_template: pdfTemplate };

  if (template.id) {
    payload.id = template.id;
  }

  const response = await PdfTemplateModelMC.save(payload);
  return mapFromApi(response.pdf_template);
};

export const deleteTemplate = async (_retailerSlug, id) => {
  await PdfTemplateModelMC.remove({ id });
};

export const setDefaultTemplate = async (_retailerSlug, id) => {
  await PdfTemplateModelMC.setDefault(id);
};

export default {
  listTemplates,
  getTemplate,
  saveTemplate,
  deleteTemplate,
  setDefaultTemplate
};
